export const getPlannerRowEpochMonthAnchor = (row) => {
  const anchor = Number(
    row?.this_plan_epoch_month
      ?? row?.epoch_month_anchor
      ?? row?.epoch_month_header
      ?? row?.plan_epoch_month
      ?? row?.epoch_month
      ?? 0
  )

  return Number.isFinite(anchor) && anchor > 0 ? anchor : null
}

export const plannerRowMatchesEpochMonth = (row, epochMonth) => {
  const targetEpochMonth = Number(epochMonth || 0)
  const rowAnchor = getPlannerRowEpochMonthAnchor(row)

  if (!Number.isFinite(targetEpochMonth) || targetEpochMonth <= 0 || !Number.isFinite(rowAnchor) || rowAnchor <= 0) {
    return false
  }

  if (targetEpochMonth === rowAnchor) {
    return true
  }

  return targetEpochMonth >= rowAnchor && targetEpochMonth <= (rowAnchor + 11)
}

export const filterPlannerRowsForEpochMonth = (rows, { locationClassId = null, epochMonth = null } = {}) => {
  const source = Array.isArray(rows) ? rows : []

  const scopedByClass = (
    locationClassId === null
    || typeof locationClassId === 'undefined'
    || String(locationClassId) === ''
    || String(locationClassId) === '0'
  )
    ? source
    : source.filter((row) => String(row?.location_class_id) === String(locationClassId))

  const targetEpochMonth = Number(epochMonth || 0)
  if (!Number.isFinite(targetEpochMonth) || targetEpochMonth <= 0) {
    return scopedByClass
  }

  const exactMatches = scopedByClass.filter((row) => Number(getPlannerRowEpochMonthAnchor(row)) === targetEpochMonth)
  if (exactMatches.length) {
    return exactMatches
  }

  return scopedByClass.filter((row) => plannerRowMatchesEpochMonth(row, targetEpochMonth))
}

export const getMaxPlanVersionForEpochMonth = (
  rows,
  { locationClassId = null, epochMonth = null, isFuture = false } = {}
) => {
  const scopedRows = filterPlannerRowsForEpochMonth(rows, { locationClassId, epochMonth })
  const versions = scopedRows
    .map((row) => Number(row?.plan_version ?? 0))
    .filter((version) => Number.isFinite(version))
    .filter((version) => (isFuture ? version >= 1000 : version < 1000))

  return versions.length ? Math.max(...versions) : null
}
